import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {Store} from '@ngrx/store';
import {AppState} from '../../store/store';
import {selectDimensionComponentObjects, selectDimensionSourceGroups} from '../../store/selectors';
import {selectDataSetDimensionsGroupComponentObjects} from '../../store/dataSetDimensionsGroups/dataSetDimensionsGroups.selectors';
import {Observable} from 'rxjs';
import {DatasetDimensionsGroupComponentObjects} from '../../classes/dataset-dimensions-group-component-object';
import {DimensionComponentObjects} from '../../classes/dimension-component-object';

@Component({
  selector: 'app-dimension-selector',
  templateUrl: './dimension-selector.component.html',
  styleUrls: ['./dimension-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DimensionSelectorComponent {
  @Input() public form: FormGroup;
  @Input() public control: FormControl;
  @Input() public centerPosition: boolean = false;
  @Input() public controlName: string = 'dimension';
  @Input() public label: string = 'Dimension';
  @Input() public button: boolean = false;
  @Input() public without: boolean = false;

  @Input('categories') public categories$: Observable<DatasetDimensionsGroupComponentObjects> = this._store.select(selectDataSetDimensionsGroupComponentObjects);
  @Input('sources') public sources$: Observable<DatasetDimensionsGroupComponentObjects> = this._store.select(selectDimensionSourceGroups);
  @Input('dimensions') public dimensions$: Observable<DimensionComponentObjects> = this._store.select(selectDimensionComponentObjects);

  constructor(
    private _store: Store<AppState>
  ) {}

}
